import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/Components/Auth/AuthProvider";
import { useApiHelper } from "@/contexts";

// Query keys are keyed by persona (sub) so impersonation/group switches
// refetch naturally on top of the global invalidation.
export function useMyGroupsQuery() {
	const apiHelper = useApiHelper();
	const { user } = useAuth();

	// apiHelper is an app-lifetime singleton and deliberately excluded from
	// the query key.
	// eslint-disable-next-line @tanstack/query/exhaustive-deps
	return useQuery({
		queryKey: ["myGroups", user?.sub],
		queryFn: () => apiHelper.users.getMyGroups(),
		enabled: !!user,
	});
}

export function useUserLimitsQuery() {
	const apiHelper = useApiHelper();
	const { user } = useAuth();

	// eslint-disable-next-line @tanstack/query/exhaustive-deps
	return useQuery({
		queryKey: ["user-limits", user?.sub],
		queryFn: () => apiHelper.users.getMyLimits(),
		enabled: !!user,
	});
}
